'use client'

import type { Theme } from '@/providers/Theme/types'

import React, { createContext, useContext } from 'react'

export interface ContextType {
  headerTheme?: Theme | null
  setHeaderTheme: (theme: Theme | null) => void
}

const initialContext: ContextType = {
  headerTheme: 'light',
  setHeaderTheme: () => null,
}

const HeaderThemeContext = createContext(initialContext)

export const HeaderThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // const [headerTheme, setThemeState] = useState<Theme | undefined | null>(
  //   canUseDOM ? (document.documentElement.getAttribute('data-theme') as Theme) : undefined,
  // )
  //
  // const setHeaderTheme = useCallback((themeToSet: Theme | null) => {
  //   setThemeState(themeToSet)
  // }, [])

  return (
    <HeaderThemeContext.Provider value={{ ...initialContext }}>
      {children}
    </HeaderThemeContext.Provider>
  )
}

export const useHeaderTheme = (): ContextType => useContext(HeaderThemeContext)
